<template>
  <div>
    <div class="card-body" style="padding-bottom: 0; padding-top: 0;">
      <fieldset>
        <legend>
          Third Parties
          <div class="card-header-buttons float-right" v-if="!readonly">
            <form-button :indicator="adding" v-on:clicked="addThirdParty">
              New Third Party
            </form-button>
          </div>
        </legend>
      </fieldset>
    </div>

    <form-navigation-tabs
      :tabs="tabs"
      :active="selectedThirdPartyId"
      v-on:selected="setSelectedId"
    ></form-navigation-tabs>

    <third-party
      :incident="incident"
      :third-party="selectedThirdParty"
      :module="module"
      :tab="tab"
      :readonly="readonly"
      v-if="selectedThirdParty"
      @unsaved-data="emitSaveStatus"
      @remove-third-party="removeThirdParty"
      @tab="setActiveTab"
    ></third-party>
  </div>
</template>
<script>
import ThirdParty from './ThirdParty';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ThirdParty
  },

  data() {
    return {
      tabs: [],
      selectedThirdPartyId: null,
      adding: false,
      tab: undefined
    };
  },

  computed: {
    thirdParties() {
      return this.$store.getters['Incident/thirdParties'];
    },

    selectedThirdParty() {
      return this.thirdParties.find(
        thirdParty => thirdParty.id === this.selectedThirdPartyId
      );
    }
  },

  mounted() {
    this.setTabs();
  },

  methods: {
    setTabs() {
      if (this.thirdParties.length) {
        if (!this.selectedThirdPartyId) {
          this.setSelectedId(this.thirdParties[0].id);
        }

        this.tabs = this.thirdParties.map((thirdParty, index) => ({
          name: thirdParty.id,
          label: `Third Party ${index + 1}`
        }));
      } else {
        this.selectedThirdPartyId = null;
        this.tabs = [];
      }
    },

    setActiveTab(tab) {
      this.tab = tab;
    },

    setSelectedId(id) {
      if (this.selectedThirdPartyId != id) {
        this.selectedThirdPartyId = undefined;
        this.tab = undefined;

        setTimeout(() => {
          this.selectedThirdPartyId = id;
        }, 50);
      }
    },

    addThirdParty() {
      if (this.readonly) return;
      this.adding = false;

      window
        .swal({
          title: 'Are you sure?',
          text: 'Are you sure you want to add a new third party?',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          window.Ajax.post(`/incidents/${this.incident}/third-parties`)
            .then(response => {
              window.toastify.success('Saved', 'The third party was created!');

              this.$store.commit('Incident/addThirdParty', response.data);

              this.adding = false;
            })
            .catch(error => {
              window.toastify.error(
                'Error',
                'Oops, there was an error creating the third party'
              );

              this.adding = false;
            });
        });
    },

    removeThirdParty(thirdParty) {
      if (this.thirdParties.length) {
        this.setSelectedId(this.thirdParties[0].id);
      } else {
        this.selectedThirdPartyId = null;
      }

      this.$store.commit('Incident/removeThirdParty', thirdParty);
    },

    emitSaveStatus(status) {
      this.$emit('unsaved-data', status);
    }
  },

  watch: {
    thirdParties() {
      this.setTabs();
    }
  }
};
</script>
